import { gql } from "@/gql/__generated__";
import { Get_Organization_Members_And_InvitationsQuery } from "@/gql/__generated__/graphql";
import { useMutation } from "@apollo/client";
import { GET_ORGANIZATION_MEMBERS_AND_INVITATIONS } from "../organization/getOrganizationMembersAndInvitations";
import { ONBOARDING_STEPS_COMPLETED } from "../user/onboardingStepsCompleted";

export const CREATE_ORGANIZATION_INVITATION = gql(`
  mutation CREATE_ORGANIZATION_INVITATION($email: String!, $role: Role!, $organizationId: ID!) {
    organizationInvitationCreate(input: {email: $email, role: $role}, organizationId: $organizationId){
      __typename
      ... on InvalidEmail {
        email
      }
      ... on OrganizationInvitation {
        id
        email
        invitedAt
        role
      }
      ... on OrganizationNotFound {
        id
      }
      ... on OrganizationInvitationExists {
        email
      }
    }
  }
`);

export const useCreateOrganizationInvitation = () => {
  return useMutation(CREATE_ORGANIZATION_INVITATION, {
    update(cache, { data }) {
      if (
        !data ||
        data.organizationInvitationCreate.__typename !==
          "OrganizationInvitation"
      )
        return;
      const newOrganizationInvitation = data.organizationInvitationCreate;

      cache.updateQuery(
        { query: GET_ORGANIZATION_MEMBERS_AND_INVITATIONS },
        (cacheData) => {
          if (
            !cacheData ||
            cacheData?.organization.__typename !== "Organization"
          )
            return undefined;

          const updatedInvitationsList = [
            ...cacheData.organization.pendingInvitations,
            newOrganizationInvitation
          ];

          const updatedOrganization: Get_Organization_Members_And_InvitationsQuery =
            {
              organization: {
                ...cacheData.organization,
                pendingInvitations: updatedInvitationsList
              }
            };

          return updatedOrganization;
        }
      );
    },
    refetchQueries: [
      GET_ORGANIZATION_MEMBERS_AND_INVITATIONS,
      ONBOARDING_STEPS_COMPLETED
    ]
  });
};
